/* unplugin-vue-components disabled */import script from "./SectionHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionHeader.vue?vue&type=script&setup=true&lang=js"

import "./SectionHeader.vue?vue&type=style&index=0&id=2969e59c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2969e59c"]])

export default __exports__